var render = function render(_c,_vm){return _c('div',[(
      _vm.data.attrs.row[_vm.data.attrs.column] != null &&
      _vm.data.attrs.row[_vm.data.attrs.column].length > 60
    )?_c('el-popover',{staticStyle:{"cursor":"pointer"},attrs:{"title":"Mensaje Completo","content":_vm.data.attrs.row[_vm.data.attrs.column],"trigger":"hover","placement":"top","width":"500","offset":"-140"}},[_c('span',{attrs:{"slot":"reference"},slot:"reference"},[_vm._v(_vm._s(_vm.data.attrs.row[_vm.data.attrs.column].substring(0, 60))+"...")])]):_c('span',[_vm._v(_vm._s(_vm.data.attrs.row[_vm.data.attrs.column]))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }